// eslint-disable-next-line no-restricted-imports
import { Comment, RootMutationType, Share } from 'gqlTypes/expansiveTypes'

import { augmentResolvers } from './dummyData.augment'
import { Mutation } from '../resolvers'

interface AugmentedTypesMap {
  Share: Share
  Comment: Comment
  // Root GraphQL types are a bit "special" here
  Mutation: RootMutationType
}

export const resolvers = augmentResolvers<AugmentedTypesMap>({
  Share: {},
  Comment: {
    isOptimistic: () => false,
  },
  Mutation,
})
